const ACCOUNT_KEY = 'current_account'

const CAMPAIGN_KEY = 'current_campaign'

export function setAccountId (accountId: number | undefined): void {
    sessionStorage.setItem(ACCOUNT_KEY, String(accountId))
}

export function getAccountId (): number {
    return Number(sessionStorage.getItem(ACCOUNT_KEY))
}

export function setCampaignId (campaignId: number | undefined): void {
    sessionStorage.setItem(CAMPAIGN_KEY, String(campaignId))
}

export function getCampaignId (): number {
    return Number(sessionStorage.getItem(CAMPAIGN_KEY))
}

export function removeCampaignId (campaignId: number): void {
    const currentCampaignId = getCampaignId()
    if (currentCampaignId === campaignId) {
        sessionStorage.removeItem(CAMPAIGN_KEY)
    }
}
